import '.j{display:grid;}.ssr-plugin'
import '.gk{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.r{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { useLocation } from 'wouter'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import Column from '@app/components/layout/Column'

export const TopicCommunityPageKnowledgeHub = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage
  const [, setLocation] = useLocation()
  const modules = topicCommunity?.knowledgeHubModules ?? []

  if (modules.length === 0) {
    return (
      <Column gap={'0.5rem'}>
        <Title.H4>{t.knowledgeHub}</Title.H4>
        <Text.Medium style={{ color: 'var(--gray-300)' }}>
          {t.noKnowledgeHubModules}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column gap={'0.5rem'}>
      <Title.H4>{t.knowledgeHub}</Title.H4>
      <styled.div className="j gk r"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {modules.map((item) => (
          <BlogCard
            key={item.id}
            title={item.title}
            image={item.images?.[0]?.src}
            onClick={() => setLocation(pages.knowledgeHubModule(item.slug))}
          />
        ))}
      </styled.div>
    </Column>
  )
}
